import { Input } from "@shared/antd/input";
import { Tree } from "@shared/antd/tree";
import React, { FC } from "react";
import { usePositionHierarchyTree } from "../model/usePositionHierarchyTree";
import { useIntl } from "react-intl";
import { PositionHierarchyTreeProps } from "../type/types";

const { Search } = Input;

export const PositionHierarchyTree: FC<PositionHierarchyTreeProps> = ({
  rootPositionId,
  changeSelectedPosition,
  getDefaultId,
}) => {
  const intl = useIntl();

  const { nodes, expandedKeys, loadedKeys, onExpand, onSelect, onSearch } =
    usePositionHierarchyTree(
      rootPositionId,
      changeSelectedPosition,
      getDefaultId,
      (count) => intl.formatMessage({ id: "vacancy" }, { count }), // Пример
    );
  return (
    <>
      <Search
        style={{ padding: "10px 5px 10px 10px" }}
        placeholder="Search"
        onSearch={onSearch}
      />
      <div style={{ height: "100%", overflowY: "scroll" }}>
        <Tree
          expandedKeys={expandedKeys}
          loadData={(node) => Promise.resolve()}
          loadedKeys={loadedKeys}
          onExpand={onExpand}
          onSelect={onSelect}
          treeData={nodes}
        />
      </div>
    </>
  );
};
